import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { fetchApi } from './fetchApi';
/**
 * This middleware generator allows you to dispatch actions with a meta:apiAction marker
 * that causes an API call to be made and the redux promise support to pass it to your
 * reducer with type actionName_FULFILLED after the call completes
 * (with _PENDING and _REJECTED actions as well)
 *
 * DEPRECATED - It seems like it would be better to use fetchApi directly as the
 * payload to an action and let the existing promise middleware do the work.
 */

export var reduxApiMiddleware = function reduxApiMiddleware(store) {
  return function (next) {
    return function (action) {
      if (!action.payload || !action.meta || !action.meta.apiAction) {
        return next(action);
      }

      var request = action.payload;
      var promise = fetchApi({
        body: request.body,
        url: request.url,
        method: action.meta.httpMethod || 'POST',
        catchErrors: true
      });

      var _action$meta = action.meta,
          apiAction = _action$meta.apiAction,
          meta = _objectWithoutProperties(_action$meta, ["apiAction"]);

      store.dispatch(_objectSpread({}, action, {
        meta: meta,
        payload: promise
      }));
      return undefined;
    };
  };
};